import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Polices OFL servies localement par Vite (ADR-092 §3) : aucune requête réseau au runtime.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/500.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import { App } from './app/App';
import { loadFontAwesomeKit } from './design-system/fontawesome';
import './design-system/styles.css';

loadFontAwesomeKit();

const root = document.getElementById('root');
if (root === null) throw new Error('Élément #root absent de index.html.');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
